import React, { useState, useRef, useEffect } from 'react';
import { useSelector } from 'react-redux';

const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

export default function JncMonthPicker({ formattedDate, onChangeDate, selected, minDate }) {
    const [isOpen, setIsOpen] = useState(false);
    const [year, setYear] = useState(selected?.getFullYear() || new Date().getFullYear());
    const wrapperRef = useRef(null);

    const current = new Date();
    const currentYear = current.getFullYear();
    const currentMonth = current.getMonth();
    const imageBaseURl = useSelector(state => state.config.image_base_url);

    useEffect(() => {
        function handleClickOutside(event) {
            if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
                setIsOpen(false);
            }
        }
        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, []);

    const handleMonthClick = monthIndex => {
        const selectedDate = new Date(year, monthIndex, 1);
        onChangeDate(selectedDate);
        setIsOpen(false);
    };
    const minYear = minDate?.getFullYear();
    const minMonth = minDate?.getMonth();


    return (
        <div className="relative w-full" ref={wrapperRef}>
            <button
                type="button"
                className="w-full px-3 py-3 bg-card-bg rounded-lg text-left !text-text"
                onClick={() => setIsOpen(!isOpen)}>
                <div className="flex justify-between px-1 items-center">
                    {formattedDate}
                    <img
                        src={`${imageBaseURl}/junoclient/dropdown-icon.svg`}
                        alt="dropdown"
                        className="w-3 h-3 invert dark:invert-0"
                    />
                </div>
            </button>

            {isOpen && (
                <div className="absolute z-50 mt-2 w-full !bg-modal-bg rounded-lg shadow-lg p-4">
                    <div className="flex items-center justify-between mb-3 !bg-primary py-1 rounded">
                        <button
                            type="button"
                            onClick={() => setYear(prev => prev - 1)}
                            className="text-2xl !text-secondary px-2">
                            ‹
                        </button>
                        <span className="text-sm font-medium !text-secondary">{year}</span>
                        <button
                            type="button"
                            onClick={() => {
                                if (year < currentYear) setYear(prev => prev + 1);
                            }}
                            disabled={year >= currentYear}
                            className={`text-xl px-2 ${
                                year >= currentYear
                                    ? '!text-table-col-title cursor-not-allowed'
                                    : '!text-secondary'
                                }`}>
                            ›
                        </button>
                    </div>

                    <div className="grid grid-cols-3 gap-2">
                        {months.map((month, idx) => {
                            const isFutureMonth = year > currentYear || (year === currentYear && idx > currentMonth);
                            const isBeforeMinMonth = minDate && (year < minYear || (year === minYear && idx < minMonth));
                            const isDisabled = isFutureMonth || isBeforeMinMonth;
                            return (
                                <button
                                    key={month}
                                    onClick={() => !isDisabled && handleMonthClick(idx)}
                                    className={`text-sm px-3 py-2 text-center rounded-lg transition text-left ${
                                        isDisabled
                                            ? 'text-[#CCCCCC] cursor-not-allowed'
                                            : '!text-text hover:!bg-actionBar-button-bg'
                                        }`}
                                    disabled={isDisabled}>
                                    {month}
                                </button>
                            );
                        })}
                    </div>
                </div>
            )}
        </div>
    );
}
